"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactSpring = require("react-spring");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
/** Easily create styles for the direction and width/height of the SlideableDrawer */


var createTransform = function createTransform(value, direction) {
  switch (direction) {
    case 'left':
      return {
        transform: "translate3d(-".concat(value, ", 0px, 0px)")
      };

    case 'right':
      return {
        transform: "translate3d(".concat(value, ", 0px, 0px)")
      };

    case 'top':
      return {
        transform: "translate3d(0px, -".concat(value, ", 0px)")
      };

    default:
      return {
        transform: "translate3d(0px, ".concat(value, ", 0px)")
      };
  }
};
/** Wrapper of the `react-spring` useTransition for our SlideableDrawer */


var useAppearTransition = function useAppearTransition(open, direction, config) {
  return (0, _reactSpring.useTransition)(!!open, null, {
    config: config,
    from: createTransform('100%', direction),
    enter: createTransform('0%', direction),
    leave: createTransform('120%', direction)
  });
};

__signature__(useAppearTransition, "useTransition{}", function () {
  return [_reactSpring.useTransition];
});

var _default = useAppearTransition;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(createTransform, "createTransform", "/builds/bA1zbJom/0/gojob/ui-bits/src/SlideableDrawer/useAppearTransition.ts");
  reactHotLoader.register(useAppearTransition, "useAppearTransition", "/builds/bA1zbJom/0/gojob/ui-bits/src/SlideableDrawer/useAppearTransition.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/SlideableDrawer/useAppearTransition.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();